import { render, staticRenderFns } from "./NewslettersNew.vue?vue&type=template&id=8004860e&scoped=true"
import script from "./NewslettersNew.vue?vue&type=script&lang=js"
export * from "./NewslettersNew.vue?vue&type=script&lang=js"
import style0 from "./NewslettersNew.vue?vue&type=style&index=0&id=8004860e&prod&lang=scss"
import style1 from "./NewslettersNew.vue?vue&type=style&index=1&id=8004860e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8004860e",
  null
  
)

export default component.exports